// @flow
import { fetchRequest } from '.';
import type { SmiaSection } from '../types';

const baseUrl = 'branchSmiaSectionTransition';
const branchSmiaSectionTransition = {
  fetch: async (
      params?: {
        dispatcherBranchOrgUnitId?: number;
        dispatcherOrgUnitId?: number;
        hideDispatcherNodes?: boolean;
      }
    ): Promise<SmiaSection[]> => {
      const findData = await fetchRequest.get(`/${baseUrl}`, {
        ...params
      });
      return findData ?? []
    }
}

export default branchSmiaSectionTransition
